<!-- eslint-disable -->
<template>
  <div class="c11_main_page">

    <!-- Loading screen visible till the interface data and event data is loaded -->
    <div v-if="DV_isLoadingPageVisible === true" class="c11_loading_screen">
      <div class="c11_loading_background_img" :class="DV_activeBreakPoint">
        <clip-loader 
          :color="'black'"
          class="c11_clip_loader" 
          :size="'100px'"
          >
        </clip-loader>
        <p class="c11_intro_loading">
          Loading...
        </p>
      </div>
    </div>  
    <!-- </end> Loading screen visible till the interface data and event data is loaded -->

    <header v-if="DV_editable === true" class="c11_device_header">
      <div class="c11_interface_actions_container">
        <div class="c11_interface_breakpoint_selector_container">
          Layout media breakpoint:
          <select
            :disabled="DV_isPageModalOpen || DV_isElementModalOpen"
            class="G_select breakpoints"
            @change="onChangeSelectedLayoutBreakpoint"
            :value="DV_activeBreakPoint"
          >
            <option
              v-for="(breakpoint, index) in DV_availableBreakpoints"
              :value="breakpoint"
              :key="index"
            >
              {{breakpoint}}
            </option>
          </select>
        </div>
        <div class="c11_interface_subpage_selector_container">
          Page:
          <select
            :disabled="DV_isPageModalOpen || DV_isElementModalOpen"
            class="G_select"
            @change="onChangeSelectedPage"
          >
            <option 
              v-for="(page, index) in C_layoutPagesList" 
              :value="page.page_uid"
              :selected="DV_activePageUid == page.page_uid"
              :key="index"
            >
              {{page.label}}
            </option>
          </select>
        </div>
        <div class="c11_interface_edit_layout_actions_container">
          <div>
            <button 
              @click.stop="onNewPageClick"
              :disabled="DV_isPageModalOpen || DV_isElementModalOpen || DV_isBackgroundModalOpen"
            >New Page</button>
            <button 
              @click.stop="addNewElement"
              :disabled="DV_isPageModalOpen || DV_isElementModalOpen || DV_isBackgroundModalOpen"
            >Add Element</button>
            <button
              @click.stop="openBackgroundModal"
              :disabled="DV_isPageModalOpen || DV_isElementModalOpen || DV_isBackgroundModalOpen"
            >Edit Background</button>
            <button
              @click.stop="onEditPageClick"
              :disabled="DV_isPageModalOpen || DV_isElementModalOpen || DV_isBackgroundModalOpen"
            >Edit Page</button>
            <button
              @click.stop="importLayoutData"
              :disabled="DV_isPageModalOpen || DV_isElementModalOpen || DV_isBackgroundModalOpen"
            >
              <i class="fas fa-file-upload"></i>
              Import layout
            </button>
            <input style="display: none" class='file-upload-button' type="file" hidden ref="importInterfaceFile" @change="handleInterfaceUpload"/>
            <button
              @click.stop="exportLayoutData"
              :disabled="DV_isPageModalOpen || DV_isElementModalOpen || DV_isBackgroundModalOpen"
            >
              <i class="fas fa-file-download"></i>
              Export Layout
            </button>
            <button 
              @click.stop="saveLayout"
              :disabled="DV_isPageModalOpen || DV_isElementModalOpen || DV_isBackgroundModalOpen"
            >Save Changes</button>
            <button 
              @click.stop="closeLayoutEditing"
              :disabled="DV_isPageModalOpen || DV_isElementModalOpen || DV_isBackgroundModalOpen"
            >Close</button>
          </div>
        </div>
      </div>
    </header>

    <!-- customer background and logo presentation layer -->
    <div class="c11_customer_presentation_layer">
      <div class="c11_customer_interface_bg" :class="DV_activeBreakPoint" :style="C_pageStyling" @click.stop="onInterfacePageClick">
        <div class="c11_interface_header">
          <div v-if="DV_activePageUid !== 'p_3'" class="c11_customer_logo" :style="C_logoImage"></div>
          <div 
            v-if="DV_editable === false && C_canEditLayout"
            class="c11_edit_button_container">
            <button 
              @click.stop="enableLayoutEditing"
            >
              <i class="fa fa-pencil"></i>
            </button>
          </div>
        </div>
        <!-- actual grid -->
        <div class="c11_interface_content_container">
          <grid-layout
            :layout.sync="DV_activeLayout"
            :col-num="DV_gridColNum"
            :row-height="DV_gridRowHeight"
            :max-rows="DV_maxRows"
            :is-draggable="DV_editable && DV_draggable"
            :is-resizable="DV_editable && DV_resizable"
            :vertical-compact="false"
            :use-css-transforms="true"
            :prevent-collision="true"
            :autoSize="false"
          >
            <grid-item
              v-for="(item, index) in DV_activeLayout"
              :key="index"
              :x="item.x"
              :y="item.y"
              :w="item.w"
              :h="item.h"
              :i="item.i"
              class="c11_grid_item_container"
              @resized="resizedEvent"
              @moved="movedEvent"
            >
              <component 
                v-if="item.element_id in C_activePageElementsData"
                :is="C_activePageElementsData[item.element_id].component_id" 
                :P_editing="DV_editable"
                :P_cpUid="DV_cpUid"
                :P_activeBreakPoint="DV_activeBreakPoint"
                :P_customClass="`wd-${item.element_id}`"
                v-bind={...C_activePageElementsData[item.element_id].available_props}
                @event-mouse-down="eventMouseDown"
                @event-mouse-release="eventMouseRelease"
                @event-mouse-click="eventMouseClick"
              ></component>
              <div v-if="DV_editable" class="c11_grid_item_actions_container">
                <i 
                  class="fas fa-edit c11_actionable" 
                  @click.stop="editIndividualComponent(item.element_id)"
                ></i>
                <i 
                  class="fas fa-trash c11_actionable" 
                  @click.stop="removeIndividualComponent(item.element_id)"
                ></i>
              </div>
            </grid-item>
          </grid-layout>
        </div>
        <!-- </end> grid -->
      </div>
      <!-- ----------  Interface Component Create/Edit Modal ---------- -->
      <div
        class="G_box c11_interface_element_modal"
        v-if="DV_editable && DV_isElementModalOpen"
      >
        <div class="c11_interface_element_modal_header">
          <p v-if="DV_isSelectedElementNew && !DV_selectedElement.hasOwnProperty('component_id')">
            Please select the element type to start.
          </p>
          <select
            v-model="DV_selectedElement.component_id"
            class="G_select"
            @change="onChangeSelectedElementType"
            :disabled="!DV_isSelectedElementNew"
          >
            <option
              v-for="(element, index) in DV_availableElements"
              :value="element.component_id"
              :selected="DV_selectedElement.component_id"
              :key="index"
            >
              {{element.component_id.substring(1)}}
            </option>
          </select>
        </div>
        <div class="c11_interface_element_modal_content">
          <p>Please select appropriate settings, then click the 'Ok' button.</p>

          <div class="c11_new_button_container">
            <button @click.stop="openAddNewEventStateModal">+ Add Event State</button>
          </div>
          
          <div class="c11_tabs">
            <button 
              :class="{'active': DV_editElementActiveTab === 'props'}"
              @click.stop="DV_editElementActiveTab = 'props'"
            >Properties</button>

            <button 
              v-for="(event, key) in DV_selectedElement.logic"
              :class="{'active': DV_editElementActiveTab === key}"
              :key="key"
              @click.stop="DV_editElementActiveTab = key"
            >
              Event {{key}}
            </button>
          </div>

          <div
            class="c11_interface_element_props"
            :style="[DV_isNewEventStateModalOpen ? {opacity: 0.3} : {opacity: 1}]"
            v-if="DV_selectedElement.hasOwnProperty('component_id') && DV_editElementActiveTab == 'props'"
          >
            <div
              v-for="(prop, key) in DV_selectedElement.available_props"
              class="c11_prop_option"
              :key="key"
            >
              <span>{{key.replace("P_", "")}}</span>
              <!-- Input type radio buttons for props to get button press event type -->
              <div v-if="key.includes('SingleEvent')" class="c11_event_type_input_container">
                <span>
                    <input 
                      :disabled="DV_isNewEventStateModalOpen" 
                      type="radio" 
                      v-model="DV_selectedElement.available_props[key]" 
                      value="single"
                      :name="`option-${key}`"
                      :id="`single-${key}`"
                    />
                    <label :for="`single-${key}`">single</label>
                </span>
                <span>
                    <input 
                      :disabled="DV_isNewEventStateModalOpen" 
                      type="radio" 
                      v-model="DV_selectedElement.available_props[key]" 
                      value="multiple"
                      :name="`option-${key}`"
                      :id="`multiple-${key}`"
                    />
                    <label :for="`multiple-${key}`">multiple</label>
                </span>
              </div>
              <!-- END Input type radio buttons for props to get button press event type -->

              <!-- Input text area for custom css -->
              <div v-else-if='key.includes("customCss")' class="c11_custom_css_editor">
                <small>Please use <code>.wd-{{DV_selectedElement.element_id}}</code> as parent selector class to make CSS scoped to this element.</small>
                <textarea
                  :disabled="DV_isNewEventStateModalOpen" 
                  type="textarea" 
                  v-model="DV_selectedElement.available_props[key]" 
                />
              </div>
              <!-- END Input text area for custom css -->

              <!-- Input type text for props to get values -->
              <input 
                v-else
                :disabled="DV_isNewEventStateModalOpen" 
                type="text" 
                v-model="DV_selectedElement.available_props[key]" 
              />
              <!-- END Input type text for props to get values -->
            </div>
          </div>
        </div>

        <div v-if="DV_editElementActiveTab !== 'props'" class="c11_element_logic_settings">
          <p>Please select appropriate settings for events logic.</p>
          <div v-for="(event, index) in DV_selectedElement.logic[DV_editElementActiveTab]" :key="index" class="c11_state_event_item">
            <div class="c11_state_event_form_row">
              <div class="c11_event_select_field">
                <span>Event Type</span>
                <select
                  v-model="event.event_type"
                  @change="$forceUpdate()"
                  class="G_select"
                >
                  <option
                    v-for="opt in DV_availableEventTypes"
                    :value="opt.value"
                    :selected="opt.value == event.event_type"
                    :key="opt.value"
                  >
                    {{opt.label}}
                  </option>
                </select>
              </div>

              <div v-if="event.event_type > 2" class="c11_event_text_field">
                <span>Eval Text</span>
                <input type="text" v-model="event.eval_text"/>
              </div>
            </div>

            <div class="c11_state_event_form_row">
              <div class="c11_event_select_field">
                <span>Event Action</span>
                <select
                  v-model="event.event_actions"
                  @change="$forceUpdate()"
                  class="G_select"
                >
                  <option
                    v-for="opt in DV_availableEventActions"
                    :value="opt.value"
                    :selected="opt.value == event.event_actions"
                    :key="opt.value"
                  >
                    {{opt.label}}
                  </option>
                </select>
              </div>

              <div v-if="event.event_actions === 3" class="c11_event_text_field">
                <span>Event Text</span>
                <input type="text" v-model="event.event_text"/>
              </div>
            </div>
            <div class="c11_event_actions">
              <small class="remove" @click.stop="removeStateEvent(index)">(Remove Logic)</small>
              <small v-if="index == (DV_selectedElement.logic[DV_editElementActiveTab].length - 1)" class="add" @click.stop="addNewLogicToEventState">(+ Add Logic)</small>
            </div>
          </div>
          <div v-if="DV_selectedElement.logic[DV_editElementActiveTab].length === 0" class="c11_event_actions">
            <small class="add" @click.stop="addNewLogicToEventState">(+ Add Logic)</small>
          </div>
        </div>
        <div class="c11_interface_element_modal_actions">
          <button 
            :disabled="DV_isNewEventStateModalOpen"
            @click.stop="validateAndSaveSelectedElementChanges"
          >
            {{DV_isSelectedElementNew ? 'Add' : 'Ok'}}
          </button>
          <button 
            :disabled="DV_isNewEventStateModalOpen"
            @click.stop="cancelSelectedElementChanges"
          >
            Cancel
          </button>
        </div>
      </div>
      <!-- </end> Modal -->

      <!-- ----------  page Modal ---------- -->
      <div
        class="G_box c11_interface_element_modal"
        v-if="DV_editable && DV_isPageModalOpen"
      >
        <div class="c11_new_button_container">
          <button @click.stop="openAddNewEventStateModal">+ Add Event State</button>
        </div>

        <div class="c11_tabs">
            <button 
              :class="{'active': DV_editPageActiveTab === 'props'}"
              @click.stop="DV_editPageActiveTab = 'props'"
            >Properties</button>

            <button 
              v-for="(event, key) in DV_selectedPage.page_logic"
              :class="{'active': DV_editPageActiveTab === key}"
              :key="key"
              @click.stop="DV_editPageActiveTab = key"
            >
              Event {{key}}
            </button>
        </div>
        <div
            class="c11_interface_element_props"
            :style="[DV_isNewEventStateModalOpen ?  {opacity: 0.3} :  {opacity: 1}]"
            v-if="DV_editPageActiveTab == 'props'"
        >
          <div class="c11_interface_element_modal_header">
            <p>Please enter a name to identify the page.</p>
            <input class="c11_input" type="text" v-model="DV_selectedPage.pageName" />
            <br><br>
            <p>Do you want to make this page clickable?</p>
            <div class="c11_event_type_input_new_page">
              <span class="c11_page_modal_radio_button">
                <input
                  type="radio"
                  v-model="DV_selectedPage.page_props.P_isPageClickable"
                  value="1"
                  id="enable"
                  class="c11_enable_radio_button"
                />
                <label for="enable" > YES </label>
              </span>
              <span class="c11_page_modal_radio_button">
                <input 
                  type="radio"
                  v-model="DV_selectedPage.page_props.P_isPageClickable"
                  value="0"
                  id="disable"
                  class="c11_input_disable"
                />
                <label for="disable" > NO </label>
              </span>
            </div>
            <br>
            <p>If the page is set to be clickable, please enter the page button ID.</p>
            <input class="c11_input" type="text" v-model="DV_selectedPage.page_props.P_pageButtonId" :disabled="DV_selectedPage.page_props.P_isPageClickable === '0'" />
            <br><br>
            <div class="c11_new_page_checkbox">
              <span>Do you want to add this page in other layouts?</span>
              <input disabled="true" type="checkbox" v-model="DV_selectedPage.newPageCheckForOtherLayouts">
            </div>
          </div>
        </div>
        <div v-if="DV_editPageActiveTab !== 'props'" class="c11_element_logic_settings">
          <p>Please select appropriate settings for events logic.</p>
          <div v-for="(event, index) in DV_selectedPage.page_logic[DV_editPageActiveTab]" :key="index" class="c11_state_event_item">
            <div class="c11_state_event_form_row">
              <div class="c11_event_select_field">
                <span>Event Type</span>
                <select
                  v-model="event.event_type"
                  @change="$forceUpdate()"
                  class="G_select"
                >
                  <option
                    v-for="opt in DV_availableEventTypes"
                    :value="opt.value"
                    :selected="opt.value == event.event_type"
                    :key="opt.value"
                  >
                    {{opt.label}}
                  </option>
                </select>
              </div>

              <div v-if="event.event_type > 2" class="c11_event_text_field">
                <span>Eval Text</span>
                <input type="text" v-model="event.eval_text"/>
              </div>
            </div>

            <div class="c11_state_event_form_row">
              <div class="c11_event_select_field">
                <span>Event Action</span>
                <select
                  v-model="event.event_actions"
                  @change="$forceUpdate()"
                  class="G_select"
                >
                  <option
                    v-for="opt in DV_availableEventActions"
                    :value="opt.value"
                    :selected="opt.value == event.event_actions"
                    :key="opt.value"
                  >
                    {{opt.label}}
                  </option>
                </select>
              </div>

              <div v-if="event.event_actions === 3" class="c11_event_text_field">
                <span>Event Text</span>
                <input type="text" v-model="event.event_text"/>
              </div>
            </div>
            <div class="c11_event_actions">
              <small class="remove" @click.stop="removeStateEvent(index)">(Remove Logic)</small>
              <small v-if="index == (DV_selectedPage.page_logic[DV_editPageActiveTab].length - 1)" class="add" @click.stop="addNewLogicToEventState">(+ Add Logic)</small>
            </div>
          </div>
          <div v-if="DV_selectedPage.page_logic[DV_editPageActiveTab].length === 0" class="c11_event_actions">
            <small class="add" @click.stop="addNewLogicToEventState">(+ Add Logic)</small>
          </div>
        </div>
        <div class="c11_interface_element_modal_actions">
          <button @click.stop="savePage">{{ DV_editingPageFlag ? 'Save' : 'Add'}}</button>
          <button @click.stop="closePageFormModal">Cancel</button>
        </div>
      </div>
      <!-- </end> Modal -->

      <!-- ----------  New Event state Modal ---------- -->
      <div
        class="G_box c11_interface_element_modal"
        style="z-index: 99;"
        v-if="DV_editable && DV_isNewEventStateModalOpen"
      >
        <div class="c11_interface_element_modal_header">
          <p>Please enter the ID for new event state.</p>
          <input class="c11_input" type="number" v-model="DV_newEventStateID">
        </div>

        <div class="c11_interface_element_modal_actions">
          <button @click.stop="addNewEventState">Add</button>
          <button @click.stop="DV_isNewEventStateModalOpen = false">Cancel</button>
        </div>
      </div>
      <!-- </end> Modal -->

      <!-- ----------  Upload Background Modal ---------- -->
      <div
        class="G_box c11_interface_background_modal"
        v-if="DV_editable && DV_isBackgroundModalOpen"
      >
        <div class="c11_interface_background_modal_header">
          <h3>Upload Interface Background</h3>
        </div>
        <div class="c11_interface_background_modal_content">
          <input type="file" @change="onChangeBackgroundSelected" accept="image/*" />
          <p>
            You're uploading a new background for the current page and
            <strong v-if="DV_activeBreakPoint === 'lg'">large</strong>
            <strong v-if="DV_activeBreakPoint === 'md'">medium</strong>
            <strong v-if="DV_activeBreakPoint === 'sm'">small</strong>
            devices.<br />
            <span>
              For optimal results, the background should be
              <em v-if="DV_activeBreakPoint === 'lg'">1280 pixels in width and 768 pixels</em>
              <em v-if="DV_activeBreakPoint === 'md'">960 pixels in width and 768 pixels</em>
              <em v-if="DV_activeBreakPoint === 'sm'">425 pixels in width and 599 pixels</em>
              in height.
            </span>
          </p>
        </div>
        <div class="c11_interface_background_modal_actions">
          <button @click.stop="uploadSelectedBackground">Upload</button>
          <button @click.stop="cancelBackgroundUpload">Cancel</button>
        </div>
      </div>
      <!-- </end> Upload Background Modal -->

      <!-- ----------  ShutDown Modal ---------- -->
      <div class="c11_modal_backdrop" v-if="DV_isShutdownModalOpen"></div>
      <div
        class="G_box c11_shutdown_modal"
        v-if="DV_isShutdownModalOpen"
      >
        <div class="c11_shutdown_modal_header">
          <h2>System Shutdown</h2>
          <div class="c11_shutdown_modal_header_shadow"></div>
        </div>
        <div class="c11_shutdown_modal_content">
          <h3>Are you sure you want to shut down the system?</h3>
        </div>
        <div class="c11_shutdown_modal_actions">
          <div class="c11_shutdown_modal_buttons">
            <div class="image-button-container">
              <span>Confirm</span>
              <a
                @click.stop="confirmSystemShutdown"
                class="image-button image-button-check"
              ></a>
            </div>
            <div class="image-button-container">
              <span>Cancel</span>
              <a
                @click.stop="cancelShutdownSystem"
                class="image-button image-button-close"
              ></a>
            </div>
          </div>
        </div>
      </div>
      <!-- </end> Modal -->
    </div>
    <!-- </end> customer background and logo presentation layer -->
  </div>
</template>

<script>
/* eslint-disable */
import VueGridLayout from 'vue-grid-layout'
import GShutdownButton from './Grid/NU_GUI/GShutdownButton'
import GCameraControl from './Grid/crestron/GCameraControl'
import GPrivacyButton from './Grid/NU_GUI/GPrivacyButton'
import GCamPrivacyButton from './Grid/NU_GUI/GCamPrivacyButton'
import GMicPanel from './Grid/NU_GUI/GMicPanel'
import GMicPanel2 from './Grid/crestron/GMicPanel2'
import GSoundPanel from './Grid/NU_GUI/GSoundPanel'
import GSoundPanel2 from './Grid/crestron/GSoundPanel2'
import GCloseButton from './Grid/crestron/GCloseButton'
import GButton from './Grid/GButton'
import GImage from './Grid/GImage'
import GInput from './Grid/GInput'
import GText from './Grid/GText'
import GList from './Grid/GList'
import GSlider from './Grid/GSlider'
import GButtonWithIcon from './Grid/GButtonWithIcon'
import GButtonWithImage from './Grid/GButtonWithImage'
import logUserControlInterfaceActivationRequest from '../watchdog_includes/json_tasks/p1s6/p1s6t2'
import GDateTime from './Grid/GDateTime'
import keepControlProcessorConnectionAlive from '../watchdog_includes/json_tasks/p1s6/p1s6t1'
import _ from "lodash"
import Vue from 'vue'
import AWN from "awesome-notifications";
import OrgNameLabel from "./labels/OrgNameLabel";
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import ControlProcessorNameLabel from "./labels/ControlProcessorNameLabel";
import GDeviceName from './Grid/GDeviceName.vue'
import GQRCodeLogin from './Grid/GQRCodeLogin.vue'
import verifyControlProcessorToken from '../watchdog_includes/json_tasks/p1s6/p1s6t10'
import css from 'css'

export default {
  name: 'c11ControlSystemInterface',
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    GShutdownButton,
    GPrivacyButton,
    GCamPrivacyButton,
    GMicPanel,
    GMicPanel2,
    GButton,
    GImage,
    GText,
    GList,
    ClipLoader,
    GInput,
    GSlider,
    GSoundPanel,
    GSoundPanel2,
    GCloseButton,
    GButtonWithIcon,
    GButtonWithImage,
    GDateTime,
    OrgNameLabel,
    GDeviceName,
    GQRCodeLogin,
    GCameraControl
  },
  data() {
    return {
      DV_editable: false,
      DV_draggable: true,
      DV_resizable: true,
      DV_responsive: true,
      DV_gridColNum: 48,
      DV_gridRowHeight: 10,
      DV_windowWidth: 0,
      DV_maxRows: 37,
      DV_orgUid: null,
      DV_cpUid: null,
      DV_cicpUid: null,
      DV_device: {
        responsive_layouts: {}
      },
      DV_selectedPage: {
        pageName: "",
        newPageCheckForOtherLayouts: true,
        page_logic: {},
        page_props: {
          P_pageButtonId: "",
          P_isPageClickable: "",
        }
      },
      DV_isPageModalOpen: false,
      DV_editingPageFlag: false,
      DV_isIntroScreenVisible: false,
      DV_isNewEventStateModalOpen: false,
      DV_newEventStateID: "",
      DV_editElementActiveTab: 'props',
      DV_editPageActiveTab: 'props',
      DV_activePageUid: 'p_1',
      DV_previousSelectedPageUid: "",
      DV_activeLayout: [],
      DV_activeBreakPoint: 'lg',
      DV_availableBreakpoints: ['lg', 'md', 'sm'],
      DV_isLoading: true,
      DV_isLoadingPageVisible: true,
      DV_pageClickLock: false,
      DV_isElementModalOpen: false,
      DV_isBackgroundModalOpen: false,
      DV_isShutdownModalOpen: false,
      DV_availableElements: window.G_web_gui_data.IV_available_graphical_elements,
      DV_selectedElement: null,
      DV_isSelectedElementNew: false,
      DV_selectedBackgroundFile: null,
      DV_graphicalElementsData: {},
      DV_unsavedGraphicalElementsData: {},
      DV_unsavedResponsiveLayoutsNewPage: {},
      DV_deviceInterfaceDataRef: {},
      DV_hasUnsavedBackground: false,
      DV_hasUnsavedChanges: false,
      DV_shutdownButtonId: null,
      DV_lastCicpEventHandledTime: {},
      DV_isLoadingTouchPanelInformation: true,
      DV_orgMetadata: {},
      DV_dataLoadingInterval: null,
      DV_popupModalOptions: {
        labels: {
          confirm: "This action will discard the Unsaved changes, Do you want to save them",
        },
        modal: { okLabel: "Save", cancelLabel: "Discard" },
        position: "center"
      },
      DV_connectionInterval: null,
      DV_availableEventTypes: [
        { value: 1, label: `Boolean True`},
        { value: 2, label: `Boolean False`},
        { value: 3, label: `Text event doesn't equal "eval_text"`},
        { value: 4, label: `Text event equals "eval_text"`},
        { value: 5, label: `Text event contains "eval_text"`},
        { value: 6, label: `Text event doesn't contain "eval_text"`}
      ],
      DV_availableEventActions: [
        {value: 1, label: `Set Element to True Feedback State`},
        {value: 2, label: `Set Element False Feedback State`},
        {value: 3, label: `Set Element text to "event_text" value`},
        {value: 4, label: `Set Element text to the value of the text event`},
        {value: 5, label: `Make Element Invisible`},
        {value: 6, label: `Make Element Visible`}
      ]
    }
  },
  created() {
    const CI = this
    window.addEventListener("resize", CI.resizeHandler)
  },
  mounted() {
    const CI = this
    if (CI.$route.query) {
      const { org_uid, cicp_uid, token } = CI.$route.query
      if (org_uid && cicp_uid) {
        /// signed-in user session: set params via Dashboard link scenario
        CI.DV_orgUid = org_uid
        CI.DV_cicpUid = cicp_uid

        CI.DV_dataLoadingInterval = setInterval(CI.waitOrgDataLoading, 1000)
        CI.waitForUserInfo()
        /// </end> signed-in user session: set params via Dashboard link scenario
      } else if (token) {
        /// guest session: set params via QR decode scenario
        const promise = verifyControlProcessorToken(token).then(
          success => {
            if (success['response']) {
              const response = JSON.parse(success['response'])
              if (response['verify_success'] === true) {
                CI.DV_cicpUid = response['cicp_uid']
                CI.DV_orgUid = response['org_uid'].toString()
                CI.DV_cpUid = response['cicp_uid']

                CI.DV_dataLoadingInterval = setInterval(CI.waitOrgDataLoading, 1000)
                CI.waitForUserInfo()
              } else {
                CI.handleInvalidParams('tokenVerificationFailed')
              }
            }
          },
          error => {
            console.log(`Something went wrong while authenticating the token/cpUID. (ref: ${JSON.stringify(error)})`)
            CI.handleInvalidParams('tokenVerificationFailed')
          }
        )
        /// </end> guest session: set params via QR decode scenario
      } else {
        CI.handleInvalidParams('invalid')
      }
    }
  },
  beforeDestroy() {
    const CI = this;
    clearInterval(CI.DV_connectionInterval);
    window.G_web_socket.clearHandleUserInteractionInterval();
  },
  computed: {
    C_logoImage() {
      const CI = this;
      let logo = "/dynamic/images/b1/NU_GUI/Northeastern-university-logo.png";
      
      let styles = {
        width: '165px',
        height: '60px'
      }
      
      if (CI.DV_activeBreakPoint in CI.DV_graphicalElementsData === true) {
        if (CI.DV_activePageUid in CI.DV_graphicalElementsData[CI.DV_activeBreakPoint] === true) {
          if ('logo' in CI.DV_graphicalElementsData[CI.DV_activeBreakPoint][CI.DV_activePageUid] === true) {
            logo = CI.DV_graphicalElementsData[CI.DV_activeBreakPoint][CI.DV_activePageUid]['logo'];
            if (CI.DV_activeBreakPoint == 'sm') {
              styles['width'] = '13rem';
              styles['height'] = '4rem';
            } else {
              styles['width'] = '25rem';
              styles['height'] = '8rem';
            }
          }
        }
      } 

      styles['background'] = `url('${logo}') no-repeat center center / cover`;
      
      return styles;
    },
    C_layoutPagesList() {
      const CI = this
      const activeBreakPoint = CI.DV_activeBreakPoint
      const pages = []
      const page_uids = Object.keys(CI.DV_device["responsive_layouts"][activeBreakPoint])

      for (let index in page_uids) {
        let p_uid = page_uids[index];
        let p_data = CI.DV_device["responsive_layouts"][activeBreakPoint][p_uid];

        if (p_data) {
          pages.push({label: p_data.page_name, page_uid: p_uid});
        }
      }

      if (CI.DV_hasUnsavedChanges && CI.DV_unsavedResponsiveLayoutsNewPage[activeBreakPoint] && CI.DV_unsavedResponsiveLayoutsNewPage[activeBreakPoint][CI.DV_activePageUid]){
        // the active page has just been added and hasn't been saved yet, we need to manually add it to the dropdown
        // If it is not present in the list already (In case of editing)
        const existingPage = pages.find((p) => p.page_uid == CI.DV_activePageUid);
        if (!existingPage) {
          pages.push({label: CI.DV_unsavedResponsiveLayoutsNewPage[activeBreakPoint][CI.DV_activePageUid]['page_name'], page_uid: CI.DV_activePageUid});
        }
      }

      return pages;
    },
    C_canEditLayout() {
      const CI = this;
      if (CI.DV_isLoadingTouchPanelInformation === true) {return false};

      if (CI.C_userPermissions.includes("a") || CI.C_userPermissions.includes("y")) {
        return true;
      }
      
      return false;
    },
    C_canControlInterface() {
      const CI = this;
      if (CI.DV_isLoadingTouchPanelInformation === true) {return false};

      if (CI.C_userPermissions.includes("a") || CI.C_userPermissions.includes("z")) {
        return true;
      }
      
      return false;
    },
    C_activePageElementsData() {
      const CI = this;

      if (CI.DV_editable === true) {
        if (CI.DV_activeBreakPoint in CI.DV_unsavedGraphicalElementsData === false) {
          return {};
        }

        var active_breakpoint_data = CI.DV_unsavedGraphicalElementsData[CI.DV_activeBreakPoint];

      } else {
        if (CI.DV_activeBreakPoint in CI.DV_graphicalElementsData === false) {
          return {};
        }

        var active_breakpoint_data = CI.DV_graphicalElementsData[CI.DV_activeBreakPoint];
      }

      if (CI.DV_activePageUid in active_breakpoint_data === false) {
        return {};
      }

      return active_breakpoint_data[CI.DV_activePageUid];
    },
    C_pageStyling() {
      const CI = this
      const breakpoint = CI.DV_activeBreakPoint
      const page = CI.DV_activePageUid
      const styles = {}
      let base64Img
      // if unsaved background present, load that one
      if (CI.DV_hasUnsavedBackground && CI.DV_unsavedGraphicalElementsData[breakpoint] && CI.DV_unsavedGraphicalElementsData[breakpoint][page] && CI.DV_unsavedGraphicalElementsData[breakpoint][page]['background_img']) {
        base64Img = CI.DV_unsavedGraphicalElementsData[breakpoint][page]['background_img']
      } else if (CI.DV_graphicalElementsData[breakpoint] && CI.DV_graphicalElementsData[breakpoint][page] && CI.DV_graphicalElementsData[breakpoint][page]['background_img']) {
        base64Img = CI.DV_graphicalElementsData[breakpoint][page]['background_img']
      } else if (CI.DV_graphicalElementsData[breakpoint] && CI.DV_graphicalElementsData[breakpoint][page] && CI.DV_graphicalElementsData[breakpoint][page]['background']) {
        var bgColor = CI.DV_graphicalElementsData[breakpoint][page]['background']
      } else {
        base64Img = `/dynamic/images/b1/default_bg_${CI.DV_activeBreakPoint}.png`;
      }
      
      if (bgColor == "" || bgColor == undefined || bgColor == null) {
        styles['background'] = `url('${base64Img}') no-repeat center center / cover`
      } else {
        styles['background'] = bgColor
      }
      
      if (CI.DV_unsavedGraphicalElementsData[breakpoint] && 
          page in CI.DV_unsavedGraphicalElementsData[breakpoint] === true &&
          'page_props' in CI.DV_unsavedGraphicalElementsData[breakpoint][page] === true &&
          'P_fontFamily' in CI.DV_unsavedGraphicalElementsData[breakpoint][page]['page_props'] === true
      ) {
        styles['font-family'] = CI.DV_unsavedGraphicalElementsData[breakpoint][page].page_props.P_fontFamily
      }
      
      return styles
    },
    C_userPermissions() {
      const CI = this;
      let permissions = "";

      const org_uid = `org_${CI.DV_orgUid}`
      if (org_uid in CI.DV_orgMetadata === true) {
        if ("permissions" in CI.DV_orgMetadata[org_uid]) {
          permissions = CI.DV_orgMetadata[org_uid]["permissions"];
        }
      }

      return permissions;
    }
  },
  methods: {
    waitForUserInfo() {
      const CI = this;
      if (window.G_firebase_auth.IV_id_token === "" || 
          window.G_web_gui_data.IV_user_info.uid === 0) {
        setTimeout(CI.waitForUserInfo, 1000);
        return;
      }
      window.G_web_gui_data.bi7GetUserPermissionData(CI.DV_orgUid, CI.DV_cicpUid);
      CI.DV_orgMetadata = window.G_web_gui_data.IV_org_metadata;
    },
    onInterfacePageClick() {
      const CI = this
      if (CI.DV_editable === true) {return;}

      const { page_props } = CI.DV_graphicalElementsData[CI.DV_activeBreakPoint][CI.DV_activePageUid];
      const isPageClickable = page_props && parseInt(page_props['P_isPageClickable'])

      if (isPageClickable === 1) {
        const pageButtonId = parseInt(page_props['P_pageButtonId'])
        if (pageButtonId) {
          CI.performPageClickUserInteraction(pageButtonId)
        } else {
          CI.$awn.warning('Button ID not set for clickable page.');
        }
      }
    },
    performPageClickUserInteraction(pageButtonId) {
      const CI = this
      // checking the lock to prevent multiple clicks on intro page.
      if (CI.DV_pageClickLock === true) {
        return
      }

      // acquiriing the lock to prevent multiple clicks on intro page.
      CI.DV_pageClickLock = true;

      // Releasing the lock automatically after 5 seconds,
      // Incase we get some issue/missed the event user should be able to make click again.
      setTimeout(function() {CI.DV_pageClickLock = false}, 5000)

      const now = new Date().getTime();
      if (CI.C_canControlInterface === false) {
        CI.$awn.warning("You don't have permisssion to send control commands. If you think this is error, please contact support.");
        return;
      }
      window.G_web_socket.bi11QueueEventSend(pageButtonId, "button_press_release", now, CI.DV_orgUid, CI.DV_cpUid, CI.DV_cicpUid)
    },
    resizeHandler() {
      const CI = this
      if (!CI.DV_editable && !CI.DV_isLoadingTouchPanelInformation) {
        CI.DV_windowWidth = window.innerWidth;
      }
    },
    confirmSystemShutdown() {
      const CI = this
      if (CI.DV_shutdownButtonId === null || CI.DV_shutdownButtonId === 0) {
        CI.$awn.warning("Button ID not set for Shutdown button.");
        return
      } 

      const integer_btn_id = parseInt(CI.DV_shutdownButtonId);
      const now = new Date().getTime();
      if (CI.C_canControlInterface === false) {
        CI.$awn.warning("You don't have permisssion to send control commands. If you think this is error, please contact support.");
        return;
      }
      window.G_web_socket.bi11QueueEventSend(integer_btn_id, "button_press_release", now, CI.DV_orgUid, CI.DV_cpUid, CI.DV_cicpUid)

      CI.DV_shutdownButtonId = null;
      CI.DV_isShutdownModalOpen = false;
    },
    cancelShutdownSystem() {
      const CI = this
      CI.DV_shutdownButtonId = null;
      CI.DV_isShutdownModalOpen = false;
    },
    waitOrgDataLoading() {
      const CI = this;
      if (window.G_web_gui_data.IV_user_organization_data_ready === false) {
        return;
      }
      clearInterval(CI.DV_dataLoadingInterval);
      const org_uid = `org_${CI.DV_orgUid}`;
      const cicp_uid = `cicp_${CI.DV_cicpUid}`;

      if (org_uid in window.G_web_gui_data.IV_user_organization_data === false) {
        CI.handleInvalidParams("permissions");
        return;
      }

      /// Finding out the CP uid for the org_uid and cicp_uid
      const orgData = window.G_web_gui_data.IV_user_organization_data[org_uid];
      const cp_uid = _.findKey(orgData, (cp_cicps, key) => { 

        if ("cicps" in cp_cicps === false) {return;}

        return Object.keys(cp_cicps["cicps"]).includes(cicp_uid)});
      /// </end> Finding out the CP uid for the org_uid and cicp_uid

      if (cp_uid === null || cp_uid === undefined) {
        CI.handleInvalidParams("unknowncp");
        return;
      }

      /// Set window title to cart name
      const cartMetaData = window.G_web_gui_data.IV_control_processors_metadata[cp_uid]
      document.title = cartMetaData['name']

      CI.DV_cpUid = cp_uid.replace("cp_", "");
      CI.logUserCICPActivationRequest();

      // Functionality to keep connection alive
      // by sending reequests every 5 minutes.
      CI.keepConnectionAlive();
      CI.DV_connectionInterval = setInterval(CI.keepConnectionAlive, 300000);

      // Open Socket connection 
      window.G_web_socket.bi11OpenConnection();
      window.G_web_socket.bi11SetEventHandlerCallbackFunction(CI.applyEventLogic);
      window.G_web_socket.bi11RequestCicpInformation(CI.DV_orgUid, CI.DV_cpUid, CI.DV_cicpUid);

      CI.DV_deviceInterfaceDataRef = window.G_web_socket.IV_cicp_layout_information_data;
    },
    handleInvalidParams(reason) {
      const CI = this;
      if (reason === "invalid")
        CI.$awn.warning("Missing/invalid URL params. Closing this window in 5 seconds");
      else if (reason === "permissions")
        CI.$awn.warning("Sorry, you don't have sufficient permissions to this room. Closing this window in 5 seconds");
      else if (reason === "unknowncp")
        CI.$awn.warning("Sorry, device not found for this room's interface, please contact the support. Closing this window in 5 seconds");
      else if (reason === "tokenVerificationFailed")
        CI.$awn.warning('Something went wrong with the verification. Please close this window and try again.');
      else
        CI.$awn.warning("Something went wrong, please contact the support. Closing this window in 5 seconds");

      setTimeout(() => window.close(), 5000);
    },
    eventMouseDown(button_id) {
      const CI = this;
      
      if (!button_id) {
        CI.$awn.warning("Button ID not set for this element.");
        return;
      }
      const integer_btn_id = parseInt(button_id);
      const now = new Date().getTime();

      if (CI.C_canControlInterface === false) {
        CI.$awn.warning("You don't have permisssion to send control commands. If you think this is error, please contact support.");
        return;
      }
      window.G_web_socket.bi11QueueEventSend(integer_btn_id, "button_press", now, CI.DV_orgUid, CI.DV_cpUid, CI.DV_cicpUid)
    },
    eventMouseRelease(button_id) {
      const CI = this;

      if (!button_id) {
        CI.$awn.warning("Button ID not set for this element.");
        return;
      }
      
      const integer_btn_id = parseInt(button_id);
      const now = new Date().getTime();

      if (CI.C_canControlInterface === false) {
        CI.$awn.warning("You don't have permisssion to send control commands. If you think this is error, please contact support.");
        return;
      }
      window.G_web_socket.bi11QueueEventSend(integer_btn_id, "button_release", now, CI.DV_orgUid, CI.DV_cpUid, CI.DV_cicpUid)
    },
    eventMouseClick(button_id, isShutdownRequest) {
      const CI = this;

      if (!button_id) {
        CI.$awn.warning("Button ID not set for this element.");
        return;
      }

      if (isShutdownRequest === true) {
        CI.DV_shutdownButtonId = button_id;
        CI.DV_isShutdownModalOpen = true;
      } else {
        const integer_btn_id = parseInt(button_id);
        const now = new Date().getTime();
        if (CI.C_canControlInterface === false) {
          CI.$awn.warning("You don't have permisssion to send control commands. If you think this is error, please contact support.");
          return;
        }
        window.G_web_socket.bi11QueueEventSend(integer_btn_id, "button_press_release", now, CI.DV_orgUid, CI.DV_cpUid, CI.DV_cicpUid)
      }

    },
    setInitialSampleData() {
      const sampleData = {
        layout_information: JSON.stringify(window.G_web_gui_data.IV_sample_layout_information_data),
        layout_elements: JSON.stringify(window.G_web_gui_data.IV_sample_layout_elements_data)
      }

      const CI = this;
      CI.$awn.info("Setting default interface data for this device.");
      CI.setTouchPanelDeviceData(sampleData, true);
    },
    setTouchPanelDeviceData(data, new_data=false) {
      const CI = this;

      CI.DV_device["responsive_layouts"] = JSON.parse(data.layout_information);
      CI.DV_graphicalElementsData = JSON.parse(data.layout_elements);

      if (CI.DV_device['responsive_layouts'][CI.DV_activeBreakPoint] &&
          CI.DV_device['responsive_layouts'][CI.DV_activeBreakPoint][CI.DV_activePageUid]
        ) {
        let active_page = CI.DV_device['responsive_layouts'][CI.DV_activeBreakPoint][CI.DV_activePageUid];

        if ('page_elements' in active_page === true) {
          CI.DV_activeLayout = CI.deepCloneArrayOfObjects(active_page["page_elements"]);
        }
      }

      if (new_data === false) { 
        CI.setMissingPropsToElements();
      }

      // Saving to backend if the data is set for first time
      if (new_data === true) {
        let resp = window.G_web_gui_data.bi7SaveCicpGuiData(
          CI.DV_orgUid,
          CI.DV_cpUid,
          CI.DV_cicpUid,
          CI.DV_device['responsive_layouts'],
          CI.DV_graphicalElementsData
        )

        resp['response_promise'].then(
          (result) => {
            location.reload();
          },
          (error) => {
            console.log(error)
            console.log(`Unable to save default template data. Error: ${JSON.stringify(error)}`);
          }
        )
        return;
      }
      // Saving to backend if the data is set for first time

      /// hiding loading page if the data is loaded
      /// The delay here is to make sure events actions performs and interface is in proper state.
      // If we didn't get event_data yet, we'll wait for 1 seconds
      if (window.G_web_socket.IV_new_event_data_received !== true) {
        setTimeout(() => {CI.DV_isLoadingPageVisible = false}, 3000); 
      
      // Else we'll wait for 0.5 seconds to make sure event action performs completely.
      } else {
        setTimeout(() => {CI.DV_isLoadingPageVisible = false}, 2000);
      } 
      /// </end> hiding loading page if the data is loaded

      CI.DV_isLoadingTouchPanelInformation = false;
      CI.resizeHandler();
    },
    setMissingPropsToElements() {
      const CI = this;

      for (let breakPoint of CI.DV_availableBreakpoints) {
        for (let page_uid in CI.DV_graphicalElementsData[breakPoint]) {
          for (let element_id in CI.DV_graphicalElementsData[breakPoint][page_uid]) {
            if (element_id == "background_img") {continue;}

            let element_data = CI.DV_graphicalElementsData[breakPoint][page_uid][element_id];
            const default_element = _.find(CI.DV_availableElements, (el) => {return el.component_id === element_data.component_id});

            if (!default_element) {continue;}

            /// Checking missing props and setting default values
            for (let prop_key in default_element.available_props) {
              if (prop_key in element_data.available_props === false) {
                element_data.available_props[prop_key] = default_element.available_props[prop_key];
              }
            }
            /// </END> Checking missing props and setting default values
          }
        }
      }
    },
    removeUnwantedPropsBeforeSave(elementsData) {
      const CI = this;

      for (let breakPoint of CI.DV_availableBreakpoints) {
        for (let page_uid in elementsData[breakPoint]) {
          for (let element_id in elementsData[breakPoint][page_uid]) {
            if (element_id == "background_img") {continue;}
            if (element_id == "page_logic") {continue;}
            if (element_id == "page_props") {continue;}

            let element_data = elementsData[breakPoint][page_uid][element_id];
            const default_element = _.find(CI.DV_availableElements, (el) => {return el.component_id === element_data.component_id});

            if (!default_element) {continue;}

            /// Checking unwanted/extra props and removing them
            for (let prop_key in element_data.available_props) {
              if (prop_key in default_element.available_props === false) {
                delete element_data.available_props[prop_key]
              }
            }
            ///</end> Checking unwanted/extra props and removing them
          }
        }
      }

      return elementsData;
    },
    logUserCICPActivationRequest() {
      const CI = this;

      if (!CI.DV_cicpUid) {
        // TOTO- redirect to dashboard with error notification
        console.log("Unable to log user cicp activation request, cicp uid not defined.");
        return;
      }
      const resp = logUserControlInterfaceActivationRequest(
        window.G_web_gui_data.IV_user_info.uid,
        window.G_firebase_auth.IV_email_address,
        window.G_firebase_auth.IV_id_token,
        CI.DV_cicpUid.replace("cicp_", "")
      );

      resp.then(
        function(success) {},
        function(error) {
          console.log(error)
          console.log(`Unable to log user's CICP activation request. Error: ${JSON.stringify(error)}`);
        }
      );
    },
    enableLayoutEditing() {
      const CI = this;
      CI.DV_unsavedGraphicalElementsData = CI.deepCloneObject(CI.DV_graphicalElementsData);
      CI.DV_editable = true
    },
    saveLayout(callback=null, args=null) {
      const CI = this

      // update DV_device with the active layout being saved
      if(CI.DV_unsavedResponsiveLayoutsNewPage[CI.DV_activeBreakPoint] !== undefined) {
        // the page might have been added at multiple breakpoints: DV_newPageCheckForOtherLayouts
        let requestedBreakpoints = Object.keys(CI.DV_unsavedResponsiveLayoutsNewPage)
        for (let index in requestedBreakpoints) {
          CI.DV_device['responsive_layouts'][requestedBreakpoints[index]][CI.DV_activePageUid] = CI.deepCloneObject(CI.DV_unsavedResponsiveLayoutsNewPage[CI.DV_activeBreakPoint][CI.DV_activePageUid])
          
          /// Only save active layout for active breakpoint
          if (requestedBreakpoints[index] === CI.DV_activeBreakPoint) {
            CI.DV_device['responsive_layouts'][requestedBreakpoints[index]][CI.DV_activePageUid]['page_elements'] = CI.deepCloneObject(CI.DV_activeLayout)
          }
          /// END Only save active layout for active breakpoint
        }
      } else {
        CI.DV_device['responsive_layouts'][CI.DV_activeBreakPoint][CI.DV_activePageUid]['page_elements'] = CI.deepCloneObject(CI.DV_activeLayout)
      }

      // update DV_graphicalElementsData with the DV_unsavedGraphicalElementsData
      // After filtering any extra/unwanted prop just like P_activeState. 
      const filteredUnSavedData = CI.removeUnwantedPropsBeforeSave(CI.deepCloneObject(CI.DV_unsavedGraphicalElementsData))
      
      // Setting the unsaved data to actual graphical elements data
      CI.DV_graphicalElementsData = filteredUnSavedData;

      // Save updated layout and graphical data
      let resp = window.G_web_gui_data.bi7SaveCicpGuiData(
        CI.DV_orgUid,
        CI.DV_cpUid,
        CI.DV_cicpUid,
        CI.DV_device['responsive_layouts'],
        CI.DV_graphicalElementsData
      )
      //</end> Save updated layout and graphical data

      var popup_options = {
        labels: {
          async: "Saving interface.",
        },
        duration: 3000,
        position: "top-right",
      };
      let notifier = new AWN(popup_options);
      const callback_function = callback;
      const callback_args = args;

      notifier.async(
        resp['response_promise'],
        (success) => {
          if (callback_function !== null && callback_function !== undefined && typeof(callback_function) === 'function') {
            if (!callback_args) {
              callback_function()
            } else if (Array.isArray(callback_args) == true) {
              callback_function(callback_args)
            } else {
              callback_function([callback_args])
            }
          }

          // reset temporary dictionaries and flags
          CI.DV_unsavedResponsiveLayoutsNewPage = {}
          CI.DV_hasUnsavedChanges = false
          CI.DV_hasUnsavedBackground = false
          //</end> reset temporary dictionaries and flags

          // DV_editable will only be set to false from within closeLayoutEditing's invocation of this method
          notifier.success("Changes saved.");
        },
        (error) => {
          console.log(error)
          notifier.warning("There was an issue saving the changes please reload page and try again.");
          console.log(`Unable to save interface changes. Error: ${JSON.stringify(error)}`);
        }
      );
    },
    importLayoutData() {
      const CI = this;

      if (CI.DV_hasUnsavedChanges === true) {
        CI.$awn.warning("You have unsaved changes, please save them first to export.");
        return;
      }

      const options = {
        labels: {
          confirm: "Important! Do you want to continue?",
        },
        modal: { okLabel: "Yes", cancelLabel: "Cancel" },
        position: "center"
      }
      var popup = new AWN(options);
      popup.confirm(
        'This action will discard any Unsaved changes and overwrite the layout interface data for this device.',
        () => {
          CI.$refs.importInterfaceFile.click();
        },
        () => {
          // Do nothing
        }
      )
    },
    handleInterfaceUpload(fileData) {
      const CI = this;

      if (!fileData.target.files || !fileData.target.files[0]) {
        CI.$awn.warning("Please choose single JSON file.");
        return;
      }

      if (fileData.target.files > 1) {
        CI.$awn.warning("Please choose single JSON file.");
        return;
      }

      var file = fileData.target.files[0];
      if (!file.type.toLowerCase().includes('json')) {
        CI.$awn.warning("Please choose JSON file only.");
        return;
      }

      var obj = URL.createObjectURL(file);
      var reader = new FileReader();

      reader.onload = function(obj) {
        let validJSON = {};

        // Check validation of JSON blob.
        try {
          validJSON = JSON.parse(obj.srcElement.result);
        } catch (e) {
          CI.$awn.warning(`Invalid JSON format, ${e.message}`);
          return;
        }

        // check presence of required keys
        if ('layout_information' in validJSON === false || typeof (validJSON['layout_information']) != 'object')  {
          CI.$awn.warning(`Invalid Layout interface data, 'layout_information' is missing.`);
          return;
        }

        if ('layout_elements' in validJSON === false || typeof (validJSON['layout_elements']) != 'object')  {
          CI.$awn.warning(`Invalid Layout interface data, 'layout_elements' is missing.`);
          return;
        }

        // Check presense of layouts 'lg' 'md' 'sm'
        var layoutsList = ['lg', 'md', 'sm']

        for (let layout in validJSON.layout_information) {
          if (!layoutsList.includes(layout) || 
              typeof (validJSON['layout_elements'][layout]) != 'object') {
              CI.$awn.warning(`Invalid interface data for ${layout} layout.`);
              return;
          }

          // Check presense of background_img,  page_props and page_logic
          if (validJSON['layout_elements'][layout]) {
            for (let page_id in validJSON['layout_elements'][layout]) {
              if ('background_img' in validJSON['layout_elements'][layout][page_id] == false ||
                  typeof (validJSON['layout_elements'][layout][page_id]['background_img']) != 'string'
              ) {
                CI.$awn.warning(`Invalid interface data for ${layout} layout, page ${page_id}, backgroung image in null or undefined.`);
                return;
              }

              if ('page_props' in validJSON['layout_elements'][layout][page_id] == false ||
                  typeof (validJSON['layout_elements'][layout][page_id]['page_props']) != 'object'
              ) {
                CI.$awn.warning(`Invalid interface data for ${layout} layout, page ${page_id}, page props are missing or undefined.`);
                return;
              }

              if ('page_logic' in validJSON['layout_elements'][layout][page_id] == false ||
                  typeof (validJSON['layout_elements'][layout][page_id]['page_logic']) != 'object'
              ) {
                CI.$awn.warning(`Invalid interface data for ${layout} layout, page ${page_id}, page_logic is missing or undefined.`);
                return;
              }
            }
          }
        }

        CI.$awn.info(`Reloading page to update interface data.`);

        const importedData = {
          layout_information: JSON.stringify(validJSON.layout_information),
          layout_elements: JSON.stringify(validJSON.layout_elements)
        }

        CI.DV_isLoadingPageVisible = true;
        CI.setTouchPanelDeviceData(importedData, true);
      }

      reader.readAsText(file)
    },
    exportLayoutData() {
      const CI = this;

      if (CI.DV_hasUnsavedChanges === true) {
        CI.$awn.warning("You haave unsaved changes, please save them first to export.");
        return;
      }
      
      var dataObj = {
        layout_information: CI.DV_device["responsive_layouts"],
        layout_elements: CI.DV_graphicalElementsData
      };

      var data = "text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(dataObj, undefined, 2));
      var a = document.createElement('a');

      a.href = 'data:' + data;
      a.download = `${this.DV_cicpUid}.json`;
      a.innerHTML = 'download JSON';

      //Firefox requires the link to be in the body
      var container = document.body.appendChild(a);

      //simulate click
      a.click();

      //remove the link when done
      document.body.removeChild(a);

    },
    openBackgroundModal() {
      const CI = this
      CI.DV_isBackgroundModalOpen = true
    },
    onEditPageClick() {
      const CI = this;
      CI.DV_editingPageFlag = true;
      CI.onNewPageClick()
    },
    cancelBackgroundUpload() {
      const CI = this
      CI.DV_isBackgroundModalOpen = false
      CI.DV_selectedBackgroundFile = null
    },
    onChangeBackgroundSelected(event) {
      const CI = this
      const selectedFile = event.target.files[0]
      CI.DV_selectedBackgroundFile = selectedFile
    },
    uploadSelectedBackground() {
      const CI = this
      // check that an image file was indeed selected
      if (CI.DV_selectedBackgroundFile === null) {
        CI.$awn.warning('No image file was selected for upload.');
        return false;
      } else {
        // create base64 image
        const reader = new FileReader()
        // set the reader onload
        reader.onload = e => {
          const b64Image = e.target.result
          // saving the image to the backend/localstorage will become effective on saveLayout()
          CI.DV_unsavedGraphicalElementsData[CI.DV_activeBreakPoint][CI.DV_activePageUid]['background_img'] = b64Image
          CI.DV_hasUnsavedChanges = true
          CI.DV_hasUnsavedBackground = true
          // reset modal state
          CI.cancelBackgroundUpload()
        }
        if (CI.DV_hasUnsavedBackground) {
          // will be set to true again on reader.onload, necessary to trigger a new C_pageStyling() cycle
          CI.DV_hasUnsavedBackground = false
        }
        // read the file as string which will trigger the onload
        reader.readAsDataURL(CI.DV_selectedBackgroundFile)
      }
    },
    addNewElement() {
      const CI = this
      CI.DV_isSelectedElementNew = true
      CI.editIndividualComponent()
    },
    closeLayoutEditing() {
      const CI = this
      if (CI.DV_hasUnsavedChanges === true) {
        var popup = new AWN(CI.DV_popupModalOptions);
        popup.confirm(
          'This action will discard the Unsaved changes, Do you want to save them?',
          () => {
            CI.saveLayout()
            CI.DV_editable = false
          },
          () => {
            CI.cancelLayoutEditing()
          }
        )
      } else {
        CI.DV_editable = false;
      }
    },
    discardUnsavedChanges(clearElementData=false) {
      const CI = this
      if (CI.DV_unsavedResponsiveLayoutsNewPage[CI.DV_activeBreakPoint]) {
        CI.DV_activePageUid = CI.DV_previousSelectedPageUid
        CI.DV_previousSelectedPageUid = ''
      }
      const active_page_data = CI.DV_device['responsive_layouts'][CI.DV_activeBreakPoint][CI.DV_activePageUid]
      if (active_page_data && 'page_elements' in active_page_data === true) {
        CI.DV_activeLayout = CI.deepCloneObject(active_page_data['page_elements'])
      }
      if (clearElementData === true) {
        CI.DV_unsavedGraphicalElementsData = {};
      } else {
        CI.DV_unsavedGraphicalElementsData = CI.deepCloneObject(CI.DV_graphicalElementsData);
      }
      
      CI.DV_unsavedResponsiveLayoutsNewPage = {}
      CI.DV_hasUnsavedChanges = false
      CI.DV_hasUnsavedBackground = false
    },
    cancelLayoutEditing() {
      const CI = this
      CI.discardUnsavedChanges(true);
      CI.DV_editable = false
    },
    editIndividualComponent(element_id) {
      const CI = this
      CI.DV_isElementModalOpen = true

      if (CI.DV_isSelectedElementNew) {
        const newElementId = `${CI.DV_activeBreakPoint}-${CI.DV_activePageUid.replace('p_', '')}-${CI.tempGenerateRandomUid()}`;
        CI.DV_selectedElement = {element_id: newElementId}
        return;
      }

      // get the element from the active layout
      for (let index = 0; index < CI.DV_activeLayout.length; index++) {
        if (CI.DV_activeLayout[index].element_id === element_id) {

          /// setting props and event to edit
          if (element_id in CI.C_activePageElementsData === true) {
            CI.DV_selectedElement = CI.deepCloneObject(CI.C_activePageElementsData[element_id]);
            CI.DV_selectedElement["element_id"] = element_id;
          }
          ///</end> setting props and event to edit
          break
        }
      }
    },
    onNewPageClick() {
      const CI = this;
      if (CI.DV_hasUnsavedChanges === false) {
        CI.openPageModal();
        return;
      }
      
      if (CI.DV_hasUnsavedChanges === true) {
        var popup = new AWN(CI.DV_popupModalOptions);
        popup.confirm(
          'This action will discard the Unsaved changes, Do you want to save them?',
          () => {
            CI.saveLayout(CI.openPageModal);
          },
          () => {
            CI.discardUnsavedChanges()
            CI.openPageModal()
          }
        )
      }
    },
    openPageModal() {
      const CI = this;
      
      CI.DV_previousSelectedPageUid = CI.DV_activePageUid;
      
      // In case of new page we'll open a fresh form
      if (CI.DV_editingPageFlag === false) {
        CI.resetPageForm();
        CI.DV_isPageModalOpen = true;
        return;
      }

      // In case of edit page we'll open a populated form with existing data.
      const page_props = CI.C_activePageElementsData.page_props;

      // If page_props not saved for the intrface.
      if (!page_props) {
        CI.resetPageForm();
        CI.DV_isPageModalOpen = true;
        return;
      }

      const activePage = CI.C_layoutPagesList.find((page) => page.page_uid == CI.DV_activePageUid);

      CI.DV_selectedPage["pageName"] = activePage ? activePage.label : "";
      CI.DV_selectedPage["page_props"]["P_pageButtonId"] = page_props.P_pageButtonId;
      CI.DV_selectedPage["page_props"]["P_isPageClickable"] = page_props.P_isPageClickable;
      CI.DV_selectedPage['page_logic'] = CI.C_activePageElementsData.page_logic || {};

      // Setting default true as functionality is disabled for now
      CI.DV_selectedPage.newPageCheckForOtherLayouts = true;
      CI.DV_isPageModalOpen = true;
    },
    resetPageForm() {
      const CI = this;

      CI.DV_selectedPage = {
        pageName: "",
        newPageCheckForOtherLayouts: true,
        page_logic: {},
        page_props: {
          P_pageButtonId: "0",
          P_isPageClickable: "0",
        }
      }
    },
    closePageFormModal() {
      const CI = this;
      CI.DV_isPageModalOpen = false;
      CI.DV_editingPageFlag = false;
      CI.DV_editElementActiveTab = 'props'
      CI.DV_editPageActiveTab = 'props';
      CI.resetPageForm();
    },
    savePage() {
      const CI = this;

      if (CI.DV_selectedPage.pageName.trim() == "") {
        CI.$awn.warning("Page name cannot be empty.");
        return;
      }

      const newPageElementsData = CI.DV_editingPageFlag ? CI.deepCloneObject(CI.C_activePageElementsData) : {};
      newPageElementsData["page_props"] = CI.DV_selectedPage.page_props;
      
      // Page clickable propert must be set to true/false (default is selected as false)
      if (newPageElementsData.page_props.P_isPageClickable === '') {
        CI.$awn.warning("page clickable property is not set.");
        return;
      } 
      
      // Checking the presence of page button ID if the page is set to be clickable.
      if (newPageElementsData.page_props.P_isPageClickable === '1') {
        if (newPageElementsData.page_props.P_pageButtonId === '' || newPageElementsData.page_props.P_pageButtonId === '0') {
          CI.$awn.warning("Button ID for clickable page cannot be empty or 0.");
          return;
        }
      } 

      // Re-setting the page button ID to be 0, if page is not clickable.
      if (newPageElementsData.page_props.P_isPageClickable === '0') {
        newPageElementsData.page_props.P_pageButtonId = '0'
      }

      if (Object.keys(CI.DV_selectedPage.page_logic).length > 0) {
        newPageElementsData["page_logic"] = CI.DV_selectedPage.page_logic;
      }

      const newPageLayoutData = {
        page_name: this.DV_selectedPage.pageName,
        page_uid: CI.DV_editingPageFlag ? CI.DV_activePageUid : CI.tempGetUniqPageUid(),
        page_elements: CI.DV_editingPageFlag ? CI.DV_activeLayout : [] 
      }

      CI.DV_unsavedGraphicalElementsData = CI.deepCloneObject(CI.DV_graphicalElementsData);
      
      // Only create page to the other layouts if we are not in edit mode and newPageCheckForOtherLayouts is set to true;
      if (CI.DV_editingPageFlag === false && CI.DV_selectedPage.newPageCheckForOtherLayouts === true) {
        for (let breakpoint in CI.DV_device["responsive_layouts"]) {

          if (breakpoint in CI.DV_unsavedResponsiveLayoutsNewPage === false) {
            CI.DV_unsavedResponsiveLayoutsNewPage[breakpoint] = {};
          }

          CI.DV_unsavedResponsiveLayoutsNewPage[breakpoint][newPageLayoutData.page_uid] = CI.deepCloneObject(newPageLayoutData)
          // also initialize an empty dictionary for elements data for new page at every breakpoint
          if (breakpoint in CI.DV_unsavedGraphicalElementsData === false) {
            CI.DV_unsavedGraphicalElementsData[breakpoint] = {};
          }
          CI.DV_unsavedGraphicalElementsData[breakpoint][newPageLayoutData.page_uid] = newPageElementsData
        }

      } else {
        const activeBreakPoint = CI.DV_activeBreakPoint
        if (activeBreakPoint in CI.DV_unsavedResponsiveLayoutsNewPage === false) {
          CI.DV_unsavedResponsiveLayoutsNewPage[activeBreakPoint] = {};
        }
        CI.DV_unsavedResponsiveLayoutsNewPage[activeBreakPoint][newPageLayoutData.page_uid] = CI.deepCloneObject(newPageLayoutData)
        // also initialize an empty dictionary for elements data for the new page at active breakpoint
        
        for (let breakpoint in CI.DV_device["responsive_layouts"]) {
          if (breakpoint in CI.DV_unsavedGraphicalElementsData === false) {
            CI.DV_unsavedGraphicalElementsData[breakpoint] = {};
          }
          CI.DV_unsavedGraphicalElementsData[breakpoint][newPageLayoutData.page_uid] = newPageElementsData;
        }
      }

      // Only reset these if we are making a new page
      if (CI.DV_editingPageFlag === false) {
        CI.DV_activeLayout = []
        CI.DV_activePageUid = newPageLayoutData.page_uid;
      }

      CI.DV_hasUnsavedChanges = true;
      CI.closePageFormModal();
    },
    onChangeSelectedPage(event) {
      const CI = this;
      const selectedPage = event.target.value;

      if (CI.DV_hasUnsavedChanges === true) {
        var popup = new AWN(CI.DV_popupModalOptions);
        popup.confirm(
          'This action will discard the Unsaved changes, Do you want to save them?',
          () => {
            CI.saveLayout(CI.updateActivePage, selectedPage);
          },
          () => {
            CI.discardUnsavedChanges()
            CI.updateActivePage(selectedPage)
          }
        )
      } else {
        CI.updateActivePage(selectedPage);
      }
    },
    updateActivePage(value) {
      const CI = this;
      CI.DV_activePageUid = value;
      const active_page = CI.DV_device['responsive_layouts'][CI.DV_activeBreakPoint][CI.DV_activePageUid]
      CI.DV_activeLayout = CI.deepCloneObject(active_page["page_elements"]);
      CI.DV_unsavedGraphicalElementsData = CI.deepCloneObject(CI.DV_graphicalElementsData);
    },
    onChangeSelectedLayoutBreakpoint(event) {
      const CI = this;
      var selectedBreakpoint = event.target.value;

      if (CI.DV_hasUnsavedChanges === true) {
        var popup = new AWN(CI.DV_popupModalOptions);
        popup.confirm(
          'This action will discard the Unsaved changes, Do you want to save them?',
          () => {
            CI.saveLayout(CI.updateActiveBreakPoint, selectedBreakpoint);
          },
          () => {
            CI.discardUnsavedChanges()
            CI.updateActiveBreakPoint(selectedBreakpoint)
          }
        )
      } else {
        CI.updateActiveBreakPoint(selectedBreakpoint);
      }
    },
    updateActiveBreakPoint(value) {
      const CI = this

      // change the active layout breakpoint
      if (value in CI.DV_device['responsive_layouts'] === true) {
        CI.DV_activeBreakPoint = value
      }
      var active_page = CI.DV_device['responsive_layouts'][CI.DV_activeBreakPoint][CI.DV_activePageUid]
      CI.DV_activeLayout = CI.deepCloneObject(active_page["page_elements"]);
      CI.DV_unsavedGraphicalElementsData = CI.deepCloneObject(CI.DV_graphicalElementsData);
    },
    onChangeSelectedElementType(event) {
      const CI = this
      const selectedComponentId = event.target.value

      // set the selected element type
      CI.DV_selectedElement['component_id'] = selectedComponentId

      // assign element props and events to DV_selectedElement according to new type
      for (let key in CI.DV_availableElements) {
        let element = CI.DV_availableElements[key];

        if (element.component_id === selectedComponentId) {
          CI.DV_selectedElement['available_props'] = Object.assign({}, element.available_props)
          break
        }
      }
    },
    validateAndSaveSelectedElementChanges() {
      const CI = this
      if (!CI.DV_selectedElement.hasOwnProperty('component_id')) {
        CI.$awn.warning("No Element Selected to add.")
        return
      }

      let customCss = null
      try {
        customCss = CI.DV_selectedElement["available_props"]["P_customCss"];
      } catch(e) {}

      // No custom CSS continue saving the element
      if (!customCss) {
        this.saveSelectedElementChanges();
        return;
      }
      
      // Validate css
      const res = css.parse(customCss, {silent: true});
      if (!res.stylesheet || !res.stylesheet.parsingErrors) {
        this.saveSelectedElementChanges();
        return;
      }

      // Got parsing errors, show warning
      if (res.stylesheet.parsingErrors.length > 0) {
        const error_message = ["Invalid CSS:"]
        res.stylesheet.parsingErrors.forEach((err) => {
          error_message.push(err.message);
        })
        CI.$awn.warning(error_message.join("\n"));
        return;
      }

      // Valid css then continue saving the element.
      this.saveSelectedElementChanges();
    },
    saveSelectedElementChanges() {
      const CI = this;

      /// Validating the correct rule logic
      let invalidEventLogic = false;

      if ('logic' in this.DV_selectedElement) {
        for (let event_id in this.DV_selectedElement['logic']) {
          let logicRules = this.DV_selectedElement['logic'][event_id];

          for (let rule of logicRules) {

            if (!rule.event_type || !rule.event_actions) {
              invalidEventLogic = true;
              break;
            }
            
            if (rule.event_type > 2 && (rule.eval_text == null || rule.eval_text == undefined)) {
              rule.eval_text = ""
            }

            if (rule.event_actions === 3 && (rule.event_text == null || rule.event_text == undefined)) {
              rule.event_text = ""
            }
          }

          if (invalidEventLogic === true) {break;}
        }
      }

      if (invalidEventLogic === true) {
        CI.$awn.warning("Invalid rule logic for event.");
        return;
      }
      ///<end> Validating the correct rule logic

      if (CI.DV_isSelectedElementNew) {
        // assign grid coordinates initial dimensions and new index
        let max_id = 1;
        const max_id_element = _.maxBy(CI.DV_activeLayout, "i");
        if (max_id_element) {
          max_id = max_id_element.i;
        }

        const newElementId = CI.DV_selectedElement['element_id'];

        const newGridItem = {
          'moved': false,
          'x': 1,
          'y': 2,
          'w': 4,
          'h': 2,
          'i': max_id + 1,
          element_id: newElementId
        }

        if (CI.DV_activePageUid in CI.DV_unsavedGraphicalElementsData[CI.DV_activeBreakPoint] === false) {
          CI.DV_unsavedGraphicalElementsData[CI.DV_activeBreakPoint][CI.DV_activePageUid] = {};
        }
        CI.DV_unsavedGraphicalElementsData[CI.DV_activeBreakPoint][CI.DV_activePageUid][newElementId] = CI.DV_selectedElement;
        CI.DV_hasUnsavedChanges = true;
        
        /// Adding new grid item to active breakpoint 
        CI.DV_activeLayout.push(newGridItem);
        CI.DV_hasUnsavedChanges = true;
        ///</end> Adding new grid item to active breakpoint
      } else {
        const activeElementIndex = CI.DV_selectedElement['element_id']
        delete CI.DV_selectedElement['element_id']

        CI.DV_unsavedGraphicalElementsData[CI.DV_activeBreakPoint][CI.DV_activePageUid][activeElementIndex] = CI.DV_selectedElement;
        CI.DV_hasUnsavedChanges = true;
      }

      // close all modals/ reset form data and temp variables.
      CI.cancelSelectedElementChanges()
    },
    cancelSelectedElementChanges() {
      const CI = this;
      CI.DV_selectedElement = null;
      CI.DV_isSelectedElementNew = false;
      CI.DV_isElementModalOpen = false;
      CI.DV_editElementActiveTab = 'props';
    },
    removeIndividualComponent(element_id) {
      // ask for user confirmation before removing element
      const CI = this
      CI.$awn.confirm(
        'Are you sure you want to remove the element?',
        () => {
          delete CI.DV_unsavedGraphicalElementsData[CI.DV_activeBreakPoint][CI.DV_activePageUid][element_id];
          let index = CI.DV_activeLayout.findIndex((item) => item.element_id === element_id)

          if (index > -1) {
            Vue.delete(CI.DV_activeLayout, index);
          }

          CI.DV_hasUnsavedChanges = true;
        },
        () => {
          // cancelled, do nothing
        }
      )
    },
    resizedEvent() {
      const CI = this;
      CI.DV_hasUnsavedChanges = true;
    },
    movedEvent() {
      const CI = this;
      CI.DV_hasUnsavedChanges = true;
    },

    /// these are temporary functions until we start getting data from backend.
    tempGenerateRandomUid() {
      return Math.random().toString(36).substring(4).toUpperCase();
    },
    tempGetUniqPageUid() {
      const CI = this;
      var new_uid = "";

      for (;;) {
        new_uid = `p_${Math.random().toString(36).substring(8).toUpperCase()}`;

        if (new_uid in CI.DV_device["responsive_layouts"]["lg"] === false) {
          break;
        }
      } 

      return new_uid;
    },
    ///</end> these are temporary functions until we start getting data from backend.

    deepCloneObject(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    deepCloneArrayOfObjects(arr) {
      return [...arr.map(a => ({...a}))];
    },
    keepConnectionAlive() {
      const CI = this;
      if (!window.G_vue_instance || 
          window.G_vue_instance.$root.$data.webGui.watchdogDbConnected === false) {
        setTimeout(CI.keepConnectionAlive, 1000)
        return;
      }

      keepControlProcessorConnectionAlive(
        window.G_web_gui_data.IV_user_info.uid,
        window.G_firebase_auth.IV_email_address,
        window.G_firebase_auth.IV_id_token,
        CI.DV_cpUid,
        CI.DV_orgUid,
        CI.DV_cicpUid
      )
    },
    applyEventLogic(event) {
      const CI = this;

      if (Object.keys(CI.DV_graphicalElementsData).length === 0) {
        setTimeout(function() {CI.applyEventLogic(event)}, 200)
        return
      }

      const event_id = event[0];
      const event_time = event[1];
      const event_type = event[2];
      const event_content = event[3];

      /// Checking if we get latest data for this specific event_id
      if (event_id in CI.DV_lastCicpEventHandledTime === true) {
        if (event_time <= CI.DV_lastCicpEventHandledTime[event_id]) {
          // if we get event which time is, before than the last event applied time, we'll return.
          return;
        }
      }

      CI.DV_lastCicpEventHandledTime[event_id] = event_time;
      /// </end> Checking if we get latest data for this specific event_id

      const breakpoints = ["lg", "md", "sm"];
      /// loop through all tha break points available for this device to get active page elements on each page
      for (let point of breakpoints) {

        //skip this breakpoint if not available in graphical elements data
        if (point in CI.DV_graphicalElementsData === false) { continue; }

        const pagesData = CI.DV_graphicalElementsData[point];

        // skip this page if not available in graphical elements data
        if (CI.DV_activePageUid in pagesData === false) { continue; }

        /// loop through all pages to see if current event matches a page-level event first
        for( let page_id in pagesData) {
          let pageData = pagesData[page_id]
          if (pageData['page_logic'] && event_id in pageData['page_logic'] === true) {
            const pageEventLogics = pageData["page_logic"][event_id];
            for (let event_logic_key in pageEventLogics) {
              const page_event_logic = pageEventLogics[event_logic_key];

              /// Handle boolean event's logic here
              if (event_type === 1) {

                // skip: if we get boolean event type but this page_event_logic is not boolean type.
                if (![1,2].includes(page_event_logic.event_type)) { continue; }
                CI.performEventAction(null, event_id, page_event_logic, event_type, event_content, true);
              /// </end> Handle boolean event's logic here

              /// Handle text event's logic here
              } else if (event_type === 2) {

                // skip: if we get text event type but this page_event_logic is not text type.
                if (![3,4,5,6].includes(page_event_logic.event_type)) { continue; }
                CI.performEventAction(null, event_id, page_event_logic, event_type, event_content, true);
              }
              /// </end> Handle text event's logic here
            }
          }
        }

        /// loop through all tha break points available for this device to get active page elements on each page
        for( let page_id in pagesData) {
          const activePageData = pagesData[page_id];

          /// loop through all the elements of active page 
          for (let element_id in activePageData) {

            if (element_id === "background_img") { continue; }
            if (element_id === "page_props") { continue; }
            if (element_id === "page_logic") { continue; }

            let element = activePageData[element_id];

            // skip this element if no logic available for this element
            if (typeof element != "object" || "logic" in element === false) { continue; }

            // skip this element if this event ID is not set in element's logic
            if (event_id in element["logic"] === false) { continue;}

            const elementEventLogics = element["logic"][event_id];

            for (let event_logic_key in elementEventLogics) {
              const el_event_logic = elementEventLogics[event_logic_key];

              /// Handle boolean event's logic here
              if (event_type === 1) {

                // skip: if we get boolean event type but this el_event_logic is not boolean type.
                if (![1,2].includes(el_event_logic.event_type)) { continue; }
                CI.performEventAction(element, event_id, el_event_logic, event_type, event_content);
              /// </end> Handle boolean event's logic here

              /// Handle text event's logic here
              } else if (event_type === 2) {

                // skip: if we get text event type but this el_event_logic is not text type.
                if (![3,4,5,6].includes(el_event_logic.event_type)) { continue; }
                CI.performEventAction(element,event_id, el_event_logic, event_type, event_content);
              }
              /// </end> Handle text event's logic here
            }
          }
        }
        /// </end> loop through all the elements of active page 
      }
      ///</end> loop through all tha break points available for this device to get active page elements on each page
    },
    performEventAction(el, event_id, logic, type, content, is_page_event=false) {
      const CI = this

      /// Matching event logic 
      if (type === 1 && content == 1 && logic.event_type !== 1) {
        return;
      }

      if (type === 1 && content == 0 && logic.event_type !== 2) {
        return;
      }

      if (type === 2) {
        let perform_action = false;
        
        let logic_eval_text = logic.eval_text;
        let event_content = content;
        if (typeof(logic.eval_text) === "string") {
          logic_eval_text = logic.eval_text.toLowerCase();
        }
        if (typeof content === "string") {
          event_content = content.toLowerCase();
        }

        // Does not equal
        if (logic.event_type === 3 && logic_eval_text !== event_content) {
          perform_action = true;
        }

        // Equal
        else if (logic.event_type === 4 && logic_eval_text === event_content) {
          perform_action = true;
        }

        // contains
        else if (logic.event_type === 5 && event_content.includes(logic_eval_text)) {
          perform_action = true;
        }

        // Does not contains
        else if (logic.event_type === 6 && !event_content.includes(logic_eval_text)) {
          perform_action = true;
        }

        if (perform_action === false) {
          return;
        }
      }
      ///</end> Matching event logic 

      /// Handeling events of page
      if (is_page_event === true) {
        let activeBreakpointData = CI.DV_device['responsive_layouts'][CI.DV_activeBreakPoint];

        switch(logic.event_actions) {
          // Set the active page to the one we get in `content`
          case 1:
            for (let page_id in activeBreakpointData) {
              let pageData = activeBreakpointData[page_id]

              if (pageData.page_name === content) {
                if (CI.DV_activePageUid !== page_id) {
                  CI.updateActivePage(page_id)
                }
                break;
              }
            }
            break;

          // TODO- Handle other event actions for page if needed in future
        }
        return;
      }
      ///</end> Handeling events of page

      /// Performing action here
      switch(logic.event_actions) {
        case 1:
          el["available_props"]["P_activeState"] = 1
          break;
        case 2:
          el["available_props"]["P_activeState"] = 0
          break;
        case 3:
          if ("P_buttonText" in el["available_props"]) {
            el["available_props"]["P_buttonText"] = logic.event_text;  
          }
          if ("P_text" in el["available_props"]) {
            el["available_props"]["P_text"] = logic.event_text;
          }
          break;
        case 4:
          if ("P_buttonText" in el["available_props"]) {
            el["available_props"]["P_buttonText"] = content;  
          }
          if ("P_text" in el["available_props"]) {
            el["available_props"]["P_text"] = content;
          }
          break;
        case 5:
          el["available_props"]["P_visible"] = 0;
          break;
        case 6:
          el["available_props"]["P_visible"] = 1;
          break;
      }
      this.$forceUpdate();
      /// </end> Performing action here
    },
    openAddNewEventStateModal() {
      const CI = this;

      CI.DV_newEventStateID = "";
      CI.DV_isNewEventStateModalOpen = true;
    },
    addNewEventState() {
      const CI = this;

      if (CI.DV_isElementModalOpen === true) {
        if ("logic" in CI.DV_selectedElement === false) {
          CI.DV_selectedElement["logic"] = {};
        }

        CI.DV_selectedElement.logic[CI.DV_newEventStateID] = [];
        CI.DV_selectedElement.logic[CI.DV_newEventStateID].push({});
        CI.DV_newEventStateID = "";
        CI.DV_isNewEventStateModalOpen = false;
      }
      if (CI.DV_isPageModalOpen === true) {
        if ('page_logic' in CI.DV_selectedPage === false) {
          CI.DV_selectedPage["page_logic"] = {};
        }

        CI.DV_selectedPage.page_logic[CI.DV_newEventStateID] = [];
        CI.DV_selectedPage.page_logic[CI.DV_newEventStateID].push({});
        CI.DV_newEventStateID = "";
        CI.DV_isNewEventStateModalOpen = false;
      }
    },
    addNewLogicToEventState() {
      const CI = this;
      if (CI.DV_isElementModalOpen === true) {
        CI.DV_selectedElement.logic[CI.DV_editElementActiveTab].push({});
      }

      if (CI.DV_isPageModalOpen === true) {
        CI.DV_selectedPage.page_logic[CI.DV_editPageActiveTab].push({});
      }
      
      CI.$forceUpdate();
    },
    removeStateEvent(index) {
      const CI = this;

      if (CI.DV_isElementModalOpen === true) {
        CI.DV_selectedElement.logic[CI.DV_editElementActiveTab].splice(index, 1);

        if (CI.DV_selectedElement.logic[CI.DV_editElementActiveTab].length === 0) {
          const choice = confirm("You also want to remove Event?");
          if (choice) {
            delete CI.DV_selectedElement.logic[CI.DV_editElementActiveTab];
            CI.DV_editElementActiveTab = 'props';
          }
        }
      }

      if (CI.DV_isPageModalOpen === true) {
        CI.DV_selectedPage.page_logic[CI.DV_editPageActiveTab].splice(index, 1);

        if (CI.DV_selectedPage.page_logic[CI.DV_editPageActiveTab].length === 0) {
          const choice = confirm("You also want to remove Event?");
          if (choice) {
            delete CI.DV_selectedPage.page_logic[CI.DV_editPageActiveTab];
            CI.DV_editPageActiveTab = 'props';
          }
        }
      }
      CI.$forceUpdate();
    }
  },
  watch: {
    DV_activeBreakPoint() {
      const CI = this;
      if (CI.DV_device['responsive_layouts'][CI.DV_activeBreakPoint] &&
          CI.DV_device['responsive_layouts'][CI.DV_activeBreakPoint][CI.DV_activePageUid]
        ) {
        let active_page = CI.DV_device['responsive_layouts'][CI.DV_activeBreakPoint][CI.DV_activePageUid];

        if ('page_elements' in active_page === true) {
          CI.DV_activeLayout = CI.deepCloneObject(active_page["page_elements"]);
        }
      }
      CI.DV_unsavedGraphicalElementsData = CI.deepCloneObject(CI.DV_graphicalElementsData);
    },
    DV_windowWidth() {
      const CI = this;
      
      if (CI.DV_windowWidth <= 500) {
        CI.updateActiveBreakPoint('sm')
      } else if (CI.DV_windowWidth <= 1366 ) {
        CI.updateActiveBreakPoint('md')
      } else {
        CI.updateActiveBreakPoint('lg')
      }
    },
    DV_deviceInterfaceDataRef: {
      handler(data) {
        const CI = this;

        if (window.G_web_socket.IV_interface_data_received === false) {
          return
        }

        if (Object.keys(data.responsive_layout).length > 0) {
          CI.setTouchPanelDeviceData(data.responsive_layout);
        } else {
          CI.setInitialSampleData();
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  transition: all .5s ease;
}
.slide-fade-enter {
  transform: translateX(-100%);
}
.slide-fade-leave-to {
  transform: translateX(100%);
}

.c11_shutdown_modal {
  text-align: center;
}
.c11_shutdown_modal_buttons {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.image-button-container {
  width: 150px;
  height: 150px;
  cursor: pointer;
  .image-button {
    display: block;
    height: 100%;
    width: 100%; 
    background-position: center;
    background-repeat: no-repeat;
    background-size: 80%, 85%;
    &.image-button-check {
      background-image: url(/dynamic/images/b1/NU_GUI/check.png), url(/dynamic/images/b1/NU_GUI/square-button.png);
      &:active {
          background-image: url(/dynamic/images/b1/NU_GUI/check.png), url(/dynamic/images/b1/NU_GUI/square-button-pressed.png);
        }
    }
    &.image-button-close {
      background-image: url(/dynamic/images/b1/NU_GUI/close.png), url(/dynamic/images/b1/NU_GUI/square-button.png);
      &:active {
          background-image: url(/dynamic/images/b1/NU_GUI/close.png), url(/dynamic/images/b1/NU_GUI/square-button-pressed.png);
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/c11ControlSystemInterface.vue